import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import TypingText from '@common/typingText';
import SectionEducation from '@intro/section_education';
import SectionTech from '@intro/section_tech';
import SectionWork from '@intro/section_work';
import ContectInfoButtonModal from '@modal/modal_contectInfo';

const IntroBody = styled.div`
  & > h3 {
    margin-top: 5rem;
  }

  & > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px;
  }

  & dl {
    margin: 0;
    display: flex;
    flex-flow: column wrap;
    border-radius: 1.5rem;
    box-sizing: border-box;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  & dt {
    font-weight: bold;
  }

  & dd {
    margin: 0;
  }
`;

const StyledHighlingt = styled.span`
  color: var(--point1-color);
`;

const Intro = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [before, after] = t('introduction', { name: t('name') }).split(
    '{{identity}}'
  );

  return (
    <IntroBody>
      <TypingText
        infinity
        guide
        lang={i18n.language}
        style={{ margin: '3rem 0', textAlign: 'center' }}
      >
        <h1>{t('hello')}🙋🏻‍♀️</h1>
        <h1>
          <span>{before}</span>
          <StyledHighlingt>{t('identity')}</StyledHighlingt>
          <span>{after}</span>
        </h1>
        <p>2023 Web Portfolio</p>
      </TypingText>
      <ContectInfoButtonModal />
      {/* <h3>{`총 경력 : ${careerPeriod}`}</h3> */}
      <h3>{t('intro_section_work')}</h3>
      <SectionWork />
      <h3>{t('intro_section_tech')}</h3>
      <SectionTech />
      <h3>{t('education')}</h3>
      <SectionEducation />
    </IntroBody>
  );
};

export default Intro;
